import React from 'react'
import styled from 'styled-components'

/**
 * Linha discreta sobre o histórico do sistema anterior.
 *
 * A busca das compras antigas roda em SEGUNDO PLANO quando a tela abre e, ao terminar, a lista se
 * completa sozinha. Por isso aqui não há card, nem aviso de carregamento, nem botão: o cliente veio
 * ver as compras dele, e a única coisa que justifica ocupar espaço acima da lista é explicar, em uma
 * linha, por que uma compra antiga pode não estar ali.
 *
 * O estado vem do próprio endpoint da lista (`legacySync.status`):
 *
 * - `never`       → a linha explicativa. É o caso do cliente antigo: a lista pode estar vazia sem
 *                   que isso signifique que ele não tem compras. Nunca dizer que não há compras.
 * - `unavailable` → linha informando a indisponibilidade: o problema não é do cliente.
 * - `syncing`     → NADA. A busca é invisível e a lista se recarrega sozinha ao terminar.
 * - `synced`      → NADA. A lista já mostra as compras; qualquer aviso aqui seria ruído.
 * - `disabled`    → NADA. O recurso está desligado.
 */
const StyledAviso = styled.p`
	margin: 0 0 12px;
	font-size: 13px;
	color: #777;
	line-height: 1.4;
`

function LegacySyncBanner({ legacySync }) {
	const status = (legacySync && legacySync.status) || 'never'

	if (status === 'unavailable') {
		return (
			<StyledAviso>
				Não foi possível carregar as compras feitas no site ou aplicativo anterior. As
				compras feitas por aqui continuam na lista.
			</StyledAviso>
		)
	}

	if (status !== 'never') return null

	return (
		<StyledAviso>
			Compras feitas em nosso site ou aplicativo anterior não aparecem aqui automaticamente.
		</StyledAviso>
	)
}

export default LegacySyncBanner
